<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="row m-0 mt-3 formborder">
  <div class="col-md-4 p-1" style="display: none">
    <span class="required-lable">Product Category :</span>
    <select name="SelectProductCategory"
            id="SelectProductCategory"
            #refSelectProductCategory="ngModel"
            disabled
            [(ngModel)]="SelectProductCategory"
            class="form-control input-text-css"
            required>
      <option value="">Select Category</option>
      <option *ngFor="let productCategory of ProductCategoryDropdown"
              [value]="productCategory.ProductCatId">
        {{ productCategory.Product_Category }}
      </option>
    </select>
  </div>
  <div class="col-md-6 p-1">
    <span class="required-lable">Product Name :</span>
    <input required
           type="text"
           #refProductName="ngModel"
           name="ProductName"
           id="ProductName"
           placeholder="Product Name"
           [(ngModel)]="ProductName"
           class="form-control input-text-css"
           disabled />
  </div>
  <div class="col-md-6 p-1">
    <span class="required-lable">Product Short Name :</span>
    <input required
           type="text"
           #refProductShortName="ngModel"
           name="ProductShortName"
           id="ProductShortName"
           disabled
           [(ngModel)]="ProductShortName"
           placeholder="Product Short Name"
           class="form-control input-text-css" />
  </div>
</div>

<form #dbf="ngForm"
      class="formborder mt-2"
      style="padding: 0px 0px 0px 0px !important"
      (ngSubmit)="onSaveNewProduct()"
      novalidate>
  <div class="row m-0">
    <div class="col-md-12 p-0">
      <h1 class="product-charges">Product Charges</h1>
    </div>
    <div class="col-md-12 row m-0 p-0 ml-0">
      <div class="col-md-2 pd-1">
        <span style="font-weight: bold; margin-left: 30px">Charges head</span>
      </div>
      <div class="col-md-2 pd-1 text-center">
        <span style="font-weight: bold">Account head</span>
      </div>
      <div class="col-md-2 pd-1 text-center">
        <span style="font-weight: bold">Charges type</span>
      </div>
      <div class="col-md-1 pd-1 text-center">
        <span style="font-weight: bold">Value</span>
      </div>

      <div class="col-md-2 pd-1 text-center">
        <span style="font-weight: bold">Charges Validation Process</span>
      </div>
      <div class="col-md-1 pd-1"></div>
      <div class="col-md-1 pd-1">
        Auto Deduction in DV
        <!--<span style="font-weight:bold">Charges ApplyOn</span>-->
      </div>
      <div class="col-md-1 pd-1"></div>
    </div>
    <div class="col-md-12 row m-0 p-0 ml-0"
         *ngFor="let charges of chargesHead; let i = index">
      <div class="col-md-2 pd-1">
        <mat-checkbox [(ngModel)]="charges.select"
                      id="multipleTrunche1{{ i }}"
                      name="multipleTrunche1{{ i }}"
                      [disabled]="IsDisabledAccount && charges.Type != 'New'"></mat-checkbox>

        <input required
               type="text"
               [(ngModel)]="charges.ChagesHead"
               style="width: 170px; display: inline-block"
               disabled
               name="ChagesHead{{ i }}"
               id="ChagesHead{{ i }}"
               class="form-control input-text-css ml-1" />
      </div>
      <div class="col-md-2 pd-1">
        <select name="Account_HeadId{{ i }}"
                id="Account_HeadId{{ i }}"
                [(ngModel)]="charges.Account_HeadId"
                [disabled]="IsDisabledAccount && charges.Type != 'New'"
                class="form-control input-text-css"
                [required]="charges.select"
                #refAccount_HeadId="ngModel"
                [ngClass]="{
            'is-invalid': dbf.submitted && refAccount_HeadId.invalid,
            'alert-warning':
              refAccount_HeadId.invalid &&
              (refAccount_HeadId.dirty ||
                refAccount_HeadId.touched ||
                refAccount_HeadId.untouched)
          }">
          <option value="">Select</option>
          <option *ngFor="let ca of chargableAccount" [value]="ca.AccountId">
            {{ ca.Account_Name }}
          </option>
        </select>
      </div>
      <div class="col-md-2 pd-1">
        <select name="chargeType{{ i }}"
                id="chargeType{{ i }}"
                (change)="chargeTypeDROP(charges,i,'default')"
                [(ngModel)]="charges.Charge_Type"
                class="form-control input-text-css"
                [disabled]="IsDisabled">
          <option value="">Select</option>
          <option value="Fixed">Fixed</option>
          <option value="Percentage">Percentage</option>
          <option value="Open">Open</option>
        </select>
      </div>
      <div class="col-md-1 pd-1">
        <input type="number"
               [(ngModel)]="charges.Charge_Values"
               placeholder="Value"
               class="form-control input-text-css"
               name="ChargeValues{{ i }}"
               id="ChargeValues{{ i }}"
               [disabled]="IsDisabled || charges.Charge_Type=='Open' " />
      </div>

      <div class="col-md-2 pd-1">
        <select name="Apply_ProcessId{{ i }}"
                id="Apply_ProcessId{{ i }}"
                #refApply_ProcessId="ngModel"
                [ngClass]="{
            'is-invalid': f.submitted && refApply_ProcessId.invalid,
            'alert-warning':
              refApply_ProcessId.invalid &&
              (refApply_ProcessId.dirty ||
                refApply_ProcessId.touched ||
                refApply_ProcessId.untouched)
          }"
                [(ngModel)]="charges.Apply_ProcessId"
                class="form-control input-text-css"
                [disabled]="IsDisabled">
          <option value="">Select Process</option>
          <option *ngFor="let item of ProcessDropdown" [value]="item.ProcessId">
            {{ item.Process_Name }}
          </option>
        </select>
      </div>

      <div class="col-md-1 pd-1">
        <button type="button"
                (click)="onSwap(charges)"
                style="padding: 7px !important; margin: 0px !important"
                class="btn font-size-12 button-btn"
                *ngIf="IsDisabledAccount && charges.Type != 'New'">
          Swap A/C
        </button>
      </div>
      <div class="col-md-1 pd-1">
        <mat-checkbox [(ngModel)]="charges.IsDvDeduction"
                      id="selectDeduct{{ i }}"
                      name="selectDeduct{{ i }}"
                      [disabled]="!charges.Account_HeadId || IsDisabled"></mat-checkbox>
        <i class="fa fa-eye ml-3"
           id="SlabData{{ i }}"
           name="SlabData{{ i }}"
           *ngIf="charges.Charge_Type=='Open' && charges.IsDvDeduction && IsEdit"
           style="font-size: large; cursor: pointer"
           (click)="ViewSlabData(charges)"
           aria-label="true"
           [class.spinner]="loading"></i>

      </div>
      <div class="col-md-1 pd-1">
        <button type="button"
                class="addmore both no-head"
                (click)="addMoreFirstData()"
                [disabled]="IsDisabled"
                *ngIf="i + 1 == DefaultData && ChargesModel.Charges_Detail == 0">
          +
        </button>
      </div>


    </div>

    <form #df="ngForm" novalidate class="col-md-12 row m-0 p-0 ml-0">
      <div class="col-md-12 row m-0 p-0"
           *ngFor="let Charges1 of ChargesModel.Charges_Detail; let j = index">
        <div class="col-md-2 pd-1">
          <mat-checkbox [(ngModel)]="Charges1.Select"
                        id="multipleTrunche1{{ j }}"
                        name="multipleTrunche1{{ j }}"
                        [disabled]="IsDisabledAccount && Charges1.Type != 'New'"></mat-checkbox>

          <select name="ChagesHeadDROP{{ j }}"
                  id="ChagesHeadDROP{{ j }}"
                  style="width: 170px; display: inline-block"
                  [(ngModel)]="Charges1.ChagesHead"
                  (change)="onChangeChargesHead(Charges1, j)"
                  class="form-control input-text-css ml-1"
                  [required]="Charges1.Select"
                  #refChagesHead="ngModel"
                  [disabled]="IsDisabledAccount && Charges1.Type != 'New'"
                  [ngClass]="{
              'is-invalid': df.submitted && refChagesHead.invalid,
              'alert-warning':
                refChagesHead.invalid &&
                (refChagesHead.dirty ||
                  refChagesHead.touched ||
                  refChagesHead.untouched)
            }">
            <option value="">Select</option>
            <option *ngFor="let ca of ChargesHead1" [value]="ca.Id">
              {{ ca.ChagesHead }}
            </option>
          </select>
        </div>
        <div class="col-md-2 pd-1">
          <select name="Account_HeadIdDROP{{ j }}"
                  id="Account_HeadIdDROP{{ j }}"
                  [(ngModel)]="Charges1.Account_HeadId"
                  class="form-control input-text-css"
                  [required]="Charges1.Select"
                  #refAccount_HeadId1="ngModel"
                  [disabled]="IsDisabledAccount && Charges1.Type != 'New'"
                  [ngClass]="{
              'is-invalid': df.submitted && refAccount_HeadId1.invalid,
              'alert-warning':
                refAccount_HeadId1.invalid &&
                (refAccount_HeadId1.dirty ||
                  refAccount_HeadId1.touched ||
                  refAccount_HeadId1.untouched)
            }">
            <option value="">Select</option>
            <option *ngFor="let ca of chargableAccount" [value]="ca.AccountId">
              {{ ca.Account_Name }}
            </option>
          </select>
        </div>
        <div class="col-md-2 pd-1">
          <select name="chargeTypeDROP{{ j }}"
                  id="chargeTypeDROP{{ j }}"
                  (change)="chargeTypeDROP(Charges1,j,'')"
                  [(ngModel)]="Charges1.Charge_Type"
                  [disabled]="IsDisabled"
                  class="form-control input-text-css">
            <option value="">Select</option>
            <option value="Fixed">Fixed</option>
            <option value="Percentage">Percentage</option>
            <option value="Open">Open</option>
          </select>
        </div>
        <div class="col-md-1 pd-1">
          <input type="number"
                 [(ngModel)]="Charges1.Charge_Values"
                 placeholder="Value"
                 [disabled]="IsDisabled || Charges1.Charge_Type=='Open' "
                 name="ChargeValuesDROP{{ j }}"
                 id="ChargeValuesDROP{{ j }}"
                 class="form-control input-text-css" />
        </div>
        <div class="col-md-2 pd-1">
          <select name="Apply_ProcessIdDropdown{{j }}"
                  id="Apply_ProcessIdDropdown{{j }}"
                  #refApply_ProcessId1="ngModel"
                  [ngClass]="{
              'is-invalid': df.submitted && refApply_ProcessId1.invalid,
              'alert-warning':
                refApply_ProcessId1.invalid &&
                (refApply_ProcessId1.dirty ||
                  refApply_ProcessId1.touched ||
                  refApply_ProcessId1.untouched)
            }"
                  [(ngModel)]="Charges1.Apply_ProcessId"
                  class="form-control input-text-css"
                  [disabled]="IsDisabled">
            <option value="">Select Process</option>
            <option *ngFor="let item of ProcessDropdown"
                    [value]="item.ProcessId">
              {{ item.Process_Name }}
            </option>
          </select>
        </div>

        <div class="col-md-1 pd-1">
          <button type="button"
                  (click)="onSwap(Charges1)"
                  style="padding: 7px !important; margin: 0px !important"
                  class="btn font-size-12 button-btn"
                  *ngIf="IsDisabledAccount && Charges1.Type != 'New'">
            Swap A/C
          </button>
        </div>
        <div class="col-md-1 pd-1">
          <mat-checkbox [(ngModel)]="Charges1.IsDvDeduction"
                        id="selectDeducta{{ j}}"
                        name="selectDeducta{{ j }}"
                        [disabled]="!Charges1.Account_HeadId || IsDisabled"></mat-checkbox>
          <i class="fa fa-eye ml-3" id="SlabDataa{{ j }}"
             name="SlabDataa{{ j }}"
             *ngIf="Charges1.Charge_Type=='Open' && Charges1.IsDvDeduction && IsEdit"
             style="font-size: large; cursor: pointer"
             (click)="ViewSlabData(Charges1)"
             aria-label="true"
             [class.spinner]="loading"></i>

        </div>
        <div class="col-md-1 pd-1">
          <button type="button"
                  class="remove"
                  (click)="removeData(j)"
                  [ngClass]="{ 'no-head': j != 0 }"
                  [disabled]="IsDisabled"
                  [hidden]="IsDisabledAccount && Charges1.Type != 'New'">
            -
          </button>&nbsp;&nbsp;&nbsp;
          <button type="button"
                  class="addmore"
                  (click)="addMoreData()"
                  [ngClass]="{both: ChargesModel.Charges_Detail.length>1,'no-head': j != 0 }" [disabled]="!df.form.valid || IsDisabled"
                  *ngIf="j == ChargesModel.Charges_Detail.length - 1"> +
          </button>
        </div>

      </div>
    </form>
    <div class="col-md-12 row m-0 p-0">
      <div class="col-md-12 text-right p-1">
        <!-- <button type="button" (click)="OnCloseProductModal()" class="btn btn-light font-size-12" data-dismiss="modal">
          Cancel
        </button> -->
        <button type="button"
                (click)="onSaveNewProduct()"
                *ngIf="IsUpdate"
                class="btn font-size-12 button-btn"
                [class.spinner]="loading"
                [disabled]="!dbf.form.valid">
          Update
        </button>
        <button type="button"
                (click)="onEditAccount()"
                *ngIf="IsEdit"
                class="btn font-size-12 button-btn"
                [class.spinner]="loading">
          Edit
        </button>
      </div>
    </div>
  </div>
</form>

<div class="modal fade in"
     id="SwapAccountModel"
     tabindex="-1"
     role="dialog"
     aria-labelledby="myModalLabel"
     data-backdrop="false"
     style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Swap Account
        </h6>
        <button type="button"
                (click)="onCloseSwapAccountModel()"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <form #f="ngForm" novalidate class="formborder">
          <div class="row mt-4 ml-3">
            <div class="col-md-12">
              <select name="ChagesHeadswap"
                      id="ChagesHeadswap"
                      disabled
                      [(ngModel)]="SwapChanges.Id"
                      class="form-control input-text-css">
                <option value="">Select</option>
                <option *ngFor="let ca of mixChargesHead" [value]="ca.Id">
                  {{ ca.ChagesHead }}
                </option>
              </select>
              <!--<input [(ngModel)]="SwapChanges.ChagesHead" placeholder="Charges Value" disabled
                     name="ChargesHeadId" id="ChargesHeadId" class="form-control input-text-css">-->
            </div>
          </div>
          <div class="row mt-4 ml-3">
            <div class="col-md-6">
              <select name="OldAccountId"
                      id="OldAccountId"
                      [(ngModel)]="SwapChanges.Account_HeadId"
                      disabled
                      class="form-control input-text-css">
                <option *ngFor="let ca of chargableAccount"
                        [value]="ca.AccountId">
                  {{ ca.Account_Name }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <select name="NewAccountId"
                      id="NewAccountId"
                      [(ngModel)]="NewAccountId"
                      class="form-control input-text-css"
                      required
                      #refNewAccountId="ngModel"
                      [ngClass]="{
                  'is-invalid': f.submitted && refNewAccountId.invalid,
                  'alert-warning':
                    refNewAccountId.invalid &&
                    (refNewAccountId.dirty ||
                      refNewAccountId.touched ||
                      refNewAccountId.untouched)
                }">
                <option value="">Select Account</option>
                <option *ngFor="let ca of chargableAccount"
                        [value]="ca.AccountId">
                  {{ ca.Account_Name }}
                </option>
              </select>
            </div>
          </div>
        </form>

        <div class="text-right mb-2" style="margin-top: 6px">
          <button type="button"
                  (click)="Swap()"
                  [disabled]="!f.form.valid"
                  class="btn font-size-12 button-btn"
                  [class.spinner]="loading">
            Swap
          </button>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade in" id="AddProductHeadSlabModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
     data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto;">
  <form #dbb="ngForm" novalidate>
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 10px;">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">Add Slab Config</h6>
          <button type="button" (click)="OnCloseProductHeadSlabModal()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body ">
          <div class="row m-0 add-remove formborder mt-1">
            <div class="col-md-12 row m-0 p-0">
              <div class="col-md-3 p-1">
                <span style="font-weight:bold"></span>
              </div>
              <div class="col-md-2 p-1">
                <span style="font-weight:bold">From Loan Amount</span>
              </div>
              <div class="col-md-2 p-1">
                <span style="font-weight:bold">To Loan Amount</span>
              </div>
              <div class="col-md-2 p-1">
                <span style="font-weight:bold">Charges Type</span>
              </div>
              <div class="col-md-1 p-1">
                <span style="font-weight:bold">Charges Value</span>
              </div>
            </div>

            <div class="col-md-12 row m-0 p-0" *ngFor="let charges of HeadCharges;let i=index">
              <div class="col-md-3 p-1">
                <span>{{charges.Name}} </span>
              </div>
              <div class="col-md-2 p-1">
                <span class="greaterThan">></span>
                <input type="number" [(ngModel)]="charges.From_Values" placeholder="From"
                       name="From_Values1{{i}}" id="From_Values1{{i}}" class="pl-3 form-control input-text-css"
                       required #refFrom_Values1="ngModel" readonly
                       [ngClass]="{ 'is-invalid': dbb.submitted && refFrom_Values1.invalid,
     'alert-warning': refFrom_Values1.invalid  &&
     (refFrom_Values1.dirty || refFrom_Values1.touched || refFrom_Values1.untouched)
       }">
              </div>
              <div class="col-md-2 p-1">
                <input type="number" [(ngModel)]="charges.To_Values" placeholder="To"
                       name="To_Values1{{i}}" id="To_Values1{{i}}" (change)="ToValueChange(i)" class="form-control input-text-css"
                       required #refTo_Values1="ngModel" [min]="charges.From_Values"
                       [ngClass]="{ 'is-invalid': dbb.submitted && refTo_Values1.invalid, 'alert-warning': refTo_Values1.invalid  && (refTo_Values1.dirty
                 || refTo_Values1.touched || refTo_Values1.untouched) }">
              </div>
              <div class="col-md-2 p-1">
                <select name="chargeType1{{ i }}"
                        id="chargeType1{{ i }}"
                        [(ngModel)]="charges.ChargeType"
                        required #refchargeType1="ngModel"
                        [ngClass]="{ 'is-invalid': dbb.submitted && refchargeType1.invalid, 'alert-warning': refchargeType1.invalid
  && (refchargeType1.dirty || refchargeType1.touched || refchargeType1.untouched) }"
                        class="form-control input-text-css">
                  <option value="Fixed">Fixed</option>
                  <option value="Percentage">Percentage</option>
                </select>
              </div>
              <div class="col-md-2 p-1">
                <input type="number" [(ngModel)]="charges.Charge_Values" placeholder="Charges Value"
                       name="ChargeValues1{{i}}" id="ChargeValues1{{i}}" class="form-control input-text-css"
                       required #refChargeValues1="ngModel"
                       [ngClass]="{ 'is-invalid': dbb.submitted && refChargeValues1.invalid, 'alert-warning': refChargeValues1.invalid
                 && (refChargeValues1.dirty || refChargeValues1.touched || refChargeValues1.untouched) }">
              </div>



              <button type="button" class="remove" (click)="removeSlab(i)" [ngClass]="{'no-head':i!=0}"
                      *ngIf="HeadCharges.length>1">
                -
              </button>
              <button type="button" class="addmore" (click)="addMoreSlab(i)" [disabled]="!dbb.form.valid"
                      [ngClass]="{'both':HeadCharges.length>1,'no-head':i!=0}" *ngIf="i == HeadCharges.length-1">
                +
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" (click)="OnCloseProductHeadSlabModal()" class="btn  font-size-12 button-btn" data-dismiss="modal">
              Cancel
            </button>
            <button type="button" (click)="onSaveProductHeadSlab()"  class="btn  font-size-12 button-btn"
                    [class.spinner]="loading" [disabled]="!dbb.form.valid">
              Save
            </button>
          </div>

        </div>
      </div>
    </div>
  </form>
</div>
